<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="900">
    <div class="white pa-5">
      <v-form ref="form">
        <v-row class="pb-6">
          <v-col cols="12">
            <p class="form__title primary--text mb-6">
              {{ titleModal }}
            </p>
          </v-col>
          <v-col cols="12" sm="4" class="pr-sm-5">
            <BaseFormInput
              id-element="numberDraftContract"
              placeholder="Insira"
              v-model="form.numero"
              required
              :rules="[requiredInput]"
              validate-on-blur
              label-text="Número"
              type="number"
            />
          </v-col>
          <v-col cols="12" sm="4" class="pr-sm-5">
            <BaseFormInput
              id-element="dateDraftContract"
              placeholder="DD/MM/AAAA"
              v-model="form.emitida_em"
              required
              :rules="[requiredInput, dateTermValid]"
              validate-on-blur
              v-facade="maskDate"
              label-text="Data da Emissão"
            />
          </v-col>
          <v-col cols="12">
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" class="pr-sm-5">
            <BaseFormInput
              id-element="startTermDraftContract"
              placeholder="DD/MM/AAAA"
              v-model="form.inicio_vigencia"
              required
              :rules="[
                requiredInput,
                dateTermValid,
                effectiveDateMustBeOnOrAfterIssueDate
              ]"
              validate-on-blur
              v-facade="maskDate"
              label-text="Início da Vigência"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <BaseFormInput
              id-element="endTermDraftContract"
              placeholder="DD/MM/AAAA"
              v-model="form.fim_vigencia"
              required
              :rules="[
                requiredInput,
                dateTermValid,
                expirationDateMustBeAfterEffectiveDate
              ]"
              validate-on-blur
              v-facade="maskDate"
              label-text="Fim da Vigência"
            />
          </v-col>
          <v-col cols="12">
            <BaseFormTextArea
              id-element="reasonCancelEndorsement"
              placeholder="Inserir"
              v-model="form.comentario"
              :rules="[maxLengthTextArea]"
              label-text="Comentário"
            />
          </v-col>
          <v-col cols="12">
            <p class="primary--text mb-2 body-2 font-weight-bold">
              Anexar minuta
            </p>
          </v-col>
          <v-col cols="12">
            <DropFile
              @selected-files="addFiles"
              :multiple="false"
              class="mb-5"
              v-if="form.documents.length == 0"
            />
            <DocumentDataTable
              v-if="form.documents.length > 0"
              :documents="form.documents"
              @preview-file="onPreviewFile"
              @remove-file="onRemoveFile"
            />
            <div
              v-if="errorMessagesDocument.length > 0"
              class="v-text-field__details mt-4"
            >
              <div class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                  <div
                    v-for="(message, index) in errorMessagesDocument"
                    :key="`error-message-${index}`"
                    class="v-messages__message"
                  >
                    {{ message }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-spacer />
          <v-col
            cols="12"
            sm="5"
            md="3"
            xl="2"
            class="pr-sm-5 pb-5 pb-sm-0"
            v-if="cancelButton"
          >
            <BaseButton
              v-html="'CANCELAR'"
              color="secondary"
              outlined
              width="100%"
              @click="$emit('close')"
            />
          </v-col>
          <v-col cols="12" sm="5" md="3" xl="2">
            <BaseButton
              v-html="'SALVAR'"
              class="white--text secondary"
              width="100%"
              @click="submit"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
  </v-dialog>
</template>
<script>
import {
  requiredInput,
  dateTermValid,
  maxLengthTextArea
} from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { FILE } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import {
  formatDDMMYYYYToIsoDate,
  formatDateToDDMMYYYY
} from "@/utils/formats.js";
import _ from "lodash";
import PolicyMixin from "@/mixins/PolicyMixin";
import { parseDateDDMMYYYY } from "@/utils/formats.js";
export default {
  data: () => ({
    requiredInput,
    dateTermValid,
    maskDate,
    errorMessagesDocument: [],
    formatDDMMYYYYToIsoDate,
    formatDateToDDMMYYYY,
    form: {
      documents: [],
      fim_vigencia: null,
      emitida_em: null,
      valor: 0,
      inicio_vigencia: null,
      numero: null
    },
    maxLengthTextArea,
    parseDateDDMMYYYY,
    titleModal: null
  }),
  components: {
    DocumentDataTable,
    DropFile
  },
  mixins: [LoadingRequest, DocumentsMixin, PolicyMixin],
  created() {
    this.updateForm();
  },
  methods: {
    ...mapActions("insuranceCompany", ["requestUploadLogo"]),
    fetchQuotation() {
      this.withLoading(this.requestCurrentQuotation(this.$route.params.id));
    },
    validate() {
      if (this.form.documents.length == 0) {
        this.errorMessagesDocument = ["É preciso anexar a minuta"];
      } else {
        this.errorMessagesDocument = [];
      }
      return this.$refs.form.validate() && this.form.documents.length > 0;
    },
    async submit() {
      if (!this.validate()) return;
      try {
        const payload = await this.mountedPayload();
        this.$emit("submit", payload);
      } catch (err) {
        console.warn(err);
      }
    },
    async mountedPayload() {
      let payload = _.cloneDeep(this.form);
      payload.documents = await this.submitFiles(payload.documents);
      payload.arquivo = payload.documents[0];
      payload.emitida_em = this.formatDDMMYYYYToIsoDate(
        payload.emitida_em
      ).split("T")[0];
      payload.fim_vigencia = this.formatDDMMYYYYToIsoDate(
        payload.fim_vigencia
      ).split("T")[0];
      payload.inicio_vigencia = this.formatDDMMYYYYToIsoDate(
        payload.inicio_vigencia
      ).split("T")[0];
      return payload;
    },
    addFiles(files) {
      const documents = files.map(file => ({
        arquivo: {
          [FILE]: file,
          nome: file.name
        }
      }));
      this.form.documents = documents.slice(0, 1);
    },
    onRemoveFile(item) {
      this.form.documents = this.form.documents.filter(
        document => document.name !== item.name
      );
    },
    updateForm() {
      this.form.valor = _.cloneDeep(this.item.valor);
      this.form.fim_vigencia = this.formatDateToDDMMYYYY(
        _.cloneDeep(this.item.fim_vigencia || this.quotation.fim_vigencia)
      );
      this.form.inicio_vigencia = this.formatDateToDDMMYYYY(
        _.cloneDeep(this.item.inicio_vigencia || this.quotation.inicio_vigencia)
      );
      this.form.numero = _.cloneDeep(this.item.numero);
      this.form.emitida_em =
        this.item.emitida_em &&
        this.formatDateToDDMMYYYY(_.cloneDeep(this.item.emitida_em));
      this.form.comentario = _.cloneDeep(this.item.comentario);
      this.form.documents = (this.item.arquivo && [this.item.arquivo]) || [];
      this.titleModal = this.item.arquivo ? "EDITAR MINUTA" : "INSERIR MINUTA";
    },
    expirationDateMustBeAfterEffectiveDate(value) {
      if (!value) return true;
      const endDate = this.parseDateDDMMYYYY(this.form.fim_vigencia);
      const startDate = this.parseDateDDMMYYYY(this.form.inicio_vigencia);
      return (
        endDate > startDate ||
        "Término da vigência deve ser posterior ao início"
      );
    },
    effectiveDateMustBeOnOrAfterIssueDate(value) {
      if (!value) return true;
      const endDate = this.parseDateDDMMYYYY(this.form.inicio_vigencia);
      const startDate = this.parseDateDDMMYYYY(this.form.emitida_em);
      return (
        endDate >= startDate ||
        "Início da vigência deve ser posterior ou igual à emissão"
      );
    }
  },
  props: {
    item: {
      type: Object
    },
    quotation: {
      type: Object
    },
    cancelButton: {
      type: Boolean,
      default: true
    }
  }
};
</script>
